<template>
  <module-template
    id="scrolltainer"
    :title="$t('global.business-process.bp-definitions')"
    :canCreate="$store.state.bpDefCreatePermission"
    :createToolTip="
      $t('global.header.new', [
        $t('global.business-process.bp-definition').toLowerCase(),
      ])
    "
    canImport
    @newItem="create"
    @import="onImport"
  >
    <v-switch
      v-model="showActiveOnly"
      class="v-input--reverse mb-2"
      dense
      hide-details
      @change="loadData"
    >
      <template #label>
        <span style="color: black">{{ $t("global.msg.show-active") }}</span>
      </template>
    </v-switch>

    <ooliba-basic-table
      :headers="headers"
      :items="items"
      :loading="busy"
      sort-by="name"
      no-pagination
      :height="tableHeight(85, items?.length)"
      @row-clicked="onRowClick"
    >
      <template #[`item.active`]="{ item }">
        <v-icon small class="pr-4" v-if="item.active" color="green">
          pic-check
        </v-icon>
        <span v-else></span>
      </template>

      <template #[`item.createdOn`]="{ item }">
        {{ formatDate(item.createdOn) }}
      </template>

      <template #[`item.lastUpdate`]="{ item }">
        {{ formatDate(item.lastUpdate) }}
      </template>
    </ooliba-basic-table>

    <v-dialog v-model="showImport" width="500">
      <v-overlay absolute :value="uploading">
        <v-chip color="blue" dark>{{ $t("global.msg.importing") }}</v-chip>
      </v-overlay>

      <v-card>
        <v-card-title>{{ $t("global.business-process.import") }}</v-card-title>

        <v-form @submit.prevent="onImportConfirm" class="mx-auto">
          <v-card-text>
            <v-file-input
              show-size
              :label="$t('global.concepts.choose-file')"
              accept=".olp"
              truncate-length="100"
              v-model="file"
              outlined
            ></v-file-input>
          </v-card-text>

          <v-card-actions>
            <v-btn @click="onCancel">{{ $t("global.action.cancel") }}</v-btn>
            <v-btn color="primary" :disabled="!file" type="submit">
              {{ $t("global.modules.import") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </module-template>
</template>

<script>
import { get, postForm } from "@/model/api";
import OolibaBasicTable from "@/components/OolibaBasicTable";
import ModuleTemplate from "@/components/layout/ModuleTemplate";
import { tableHeight, formatDate } from "@/model/util";

export default {
  name: "BPDefinitionList",

  components: {
    OolibaBasicTable,
    ModuleTemplate,
  },

  data() {
    return {
      headers: [
        { text: this.$t("global.concepts.name"), value: "name" },
        { text: this.$t("global.concepts.created-on"), value: "createdOn" },
        {
          text: this.$t("global.concepts.last-version-update"),
          value: "lastUpdate",
        },
        { text: this.$t("global.business-process.active"), value: "active" },
      ],

      items: [],
      bps: [],
      showImport: false,
      file: undefined,
      valid: false,
      notEmpty: [(v) => !!v || this.$t("global.rules.mandatory")],

      busy: true,
      uploading: false,

      showActiveOnly: true,
    };
  },

  methods: {
    tableHeight,

    formatDate,

    create() {
      this.$router.push({ name: "Create BP definition" });
    },

    onImport() {
      this.showImport = true;
    },

    onCancel() {
      this.showImport = false;
      this.file = undefined;
    },

    onImportConfirm() {
      this.uploading = true;
      const formData = new FormData();

      formData.append("olpFile", this.file);

      postForm("/business-process/import", formData)
        .then(() => {
          this.showImport = false;
          this.loadData();
          this.uploading = false;
        })
        .catch((e) => {
          this.onError(e);
          this.uploading = false;
        });
      this.file = undefined;
    },

    async getBps() {
      return await get("/business-process/with-dates").catch((error) =>
        this.onError(error)
      );
    },

    onError(error) {
      if (error.message == "bpDef.import-failed") {
        this.$store.commit("showError", this.$t("global.msg.import-failed"));
      } else {
        this.$store.commit("showError", error);
      }
    },
    onRowClick(record) {
      this.$router.push({
        name: "BP definition",
        params: { bpId: record.id },
      });
    },

    async loadData() {
      this.busy = true;
      this.items = [];
      this.bps = await this.getBps();

      if (this.bps) {
        this.bps.forEach((value) => {
          if (this.showActiveOnly && value.hidden) return;

          const item = {};

          item["id"] = value.id;
          item[this.headers[0].value] = value.name;
          item[this.headers[1].value] = value.earliestVersionDate;
          item[this.headers[2].value] = value.latestVersionDate;
          item[this.headers[3].value] = !value.hidden;

          this.items.push(item);
        });
      }
      this.busy = false;
    },
  },

  created() {
    this.loadData();
  },
};
</script>
